import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  
  const INITIAL_STATE = {
    cars: null,
    loading: false,
    error: {
      flag: false,
      msg: null
    }
  }
  
  export const carlistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_CARS:
        return {
          ...state,
          loading: true
        };
      case FETCH_CARS_SUCCESS:
        return {
          ...state,
          cars: action.payload,
          loading: false
        };
      case FETCH_CARS_FAILED:
        return {
          ...state,
          cars: null,
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      case EDIT_CAR: {
        const { method, car } = action.payload || {};
        if (method === 'Delete' && car?.id && Array.isArray(state.cars)) {
          return {
            ...state,
            cars: state.cars.filter(c => c.id !== car.id)
          };
        } else if (method === 'Add' && car && Array.isArray(state.cars)) {
          return {
            ...state,
            cars: [car, ...state.cars]
          };
        } else if (method === 'Update' && car?.id && Array.isArray(state.cars)) {
          return {
            ...state,
            cars: state.cars.map(c => c.id === car.id ? { ...c, ...car } : c)
          };
        }
        return state;
      }
      default:
        return state;
    }
  };